import React from "react"
import { connect } from "react-redux"
import { useEffect, useState } from "react"
import { getClients } from "../../../redux/reducers/client/client-reducer"
import Managers from "./Managers"
import { getEntities } from "../../../redux/reducers/entity/entity-reducer"


const mapStateToProps = (state) => {

    return {
        managers: state.entity.items
    }
}

const ManagersContainer = (props) => {

    const [managers, setManagers] = useState(null)


    useEffect(() => {

        setManagers(props.managers)
    }, [props.managers])

    useEffect(() => {
        debugger
        props.getEntities('managers')

    }, [])

    debugger
    return (

        managers && <Managers managers={managers} />


    )
}


export default connect(mapStateToProps, {
    getEntities
})(ManagersContainer)